import { tap as e } from "wonka";

const refocusExchange = () => ({client: t, forward: n}) => i => {
  if ("undefined" == typeof window) {
    return n(i);
  }
  const o = new Map;
  const r = new Map;
  window.addEventListener("visibilitychange", (() => {
    if ("object" != typeof document || "visible" === document.visibilityState) {
      o.forEach((e => {
        t.reexecuteOperation(t.createRequestOperation("query", e, {
          ...e.context,
          requestPolicy: "cache-and-network"
        }));
      }));
    }
  }));
  return n(e((e => {
    if ("query" === e.kind && !r.has(e.key)) {
      r.set(e.key, 1);
      o.set(e.key, e);
    }
    if ("teardown" === e.kind && r.has(e.key)) {
      r.delete(e.key);
      o.delete(e.key);
    }
  }))(i));
};

export { refocusExchange };
//# sourceMappingURL=urql-exchange-refocus.mjs.map
